<template>
    <div id="modal-calculator" aria-hidden="true" class="modal modal-calculator calculator-scoped">
        <div tabindex="-1" class="modal-wrapp">
            <div role="dialog" aria-modal="true" class="modal-body">
                <div class="calculator-head">
                    <a href="#" class="calculator-back-btn" :class="{active: isBackButtonActive}"
                       @click.prevent="backButton" aria-label="Назад">
                        <svg width="12" height="12">
                            <use xlink:href="#icon-angle-left"/>
                        </svg>
                    </a>
                    <div class="calculator-head-titles">
                        <div class="calculator-progress tab-block" :class="{active: currentStep <= 3}">
                            <div class="calculator-progress-title">
                                Шаг <span class="calculator-current-step" @click="debugCounter++">{{ currentStep }}</span> из 3
                            </div>
                            <div class="calculator-pagination">
                                <div class="calculator-pagination-bullet" :class="{active: currentStep === 1}"
                                     @click="bulletStep(1)"></div>
                                <div class="calculator-pagination-bullet" :class="{active: currentStep === 2}"
                                     @click="bulletStep(2)"></div>
                                <div class="calculator-pagination-bullet" :class="{active: currentStep === 3}"></div>
                            </div>
                        </div>
                        <div class="calculator-head-title h2 tab-block" :class="{active: currentStep === 4}">
                            Корзина
                        </div>
                        <div class="calculator-head-title h2 tab-block" :class="{active: currentStep === 5}">
                            Получатель
                        </div>
                    </div>
                    <a href="#" class="modal-close-btn" aria-label="Закрыть" data-modal-close>
                        <svg width="12" height="12">
                            <use xlink:href="#icon-close"/>
                        </svg>
                    </a>
                </div>
                <div class="calculator-body">
                    <div class="calculator-step calculator-step-catalog tab-block" :class="{active: currentStep === 1}"
                         v-if="currentStep === 1">
                        <div class="calculator-step-title h2">Выберите тип изделия:</div>
                        <ul class="calculator-types">
                            <li v-for="type in currentTypes" :key="type['ID']">
                                <a href="#" class="calculator-type" @click.prevent="chooseType(type)">
                                    <span class="calculator-type-body">
                                        <span class="calculator-type-title h3">{{ type['NAME'] }}</span>
                                        <span class="calculator-type-desc" v-html="type['DESCRIPTION']">
                                        </span>
                                    </span>
                                    <span class="calculator-type-img cover-img">
                                        <picture v-if="type['PICTURE']">
                                            <source :srcset="type['PICTURE']['SRC'] + ' 1x'"
                                                    :type="type['PICTURE']['CONTENT_TYPE']">
                                            <img :src="type['PICTURE']['SRC']" :alt="type['NAME']">
                                        </picture>
                                    </span>
                                </a>
                            </li>
                        </ul>
                        <!--<ul class="calculator-categories">
                            <li v-for="type in currentTypes" :key="type['ID']">
                                <a href="#" class="calculator-category" @click.prevent="chooseType(type)">
                                    <span class="calculator-category-title h3">
                                        {{ type['NAME'] }}
                                    </span>
                                    <span class="calculator-category-img">
                                        <picture v-if="type['PICTURE']">
                                            <source :srcset="type['PICTURE']['SRC'] + ' 1x'"
                                                    :type="type['PICTURE']['CONTENT_TYPE']">
                                            <img :src="type['PICTURE']['SRC']" :alt="type['NAME']">
                                        </picture>
                                    </span>
                                </a>
                            </li>
                        </ul>-->
                    </div>

                    <div class="calculator-step calculator-step-catalog tab-block" :class="{active: currentStep === 2}"
                         v-if="currentStep === 2">
                        <div class="calculator-step-title h2">Выберите тип конструкции:</div>
                        <ul class="calculator-types">
                            <li v-for="construct in currentConstructs" :key="construct['ID']">
                                <a href="#" class="calculator-type" @click.prevent="chooseConstruct(construct)">
                                    <span class="calculator-type-body">
                                        <span class="calculator-type-title h3">{{ construct['NAME'] }}</span>
                                        <span class="calculator-type-desc"
                                              v-for="description in construct['DESCRIPTION_VALUE']">
                                            {{ description }}
                                        </span>
                                        <span class="calculator-type-desc">
                                            Цена от: {{ construct['MIN_PRICE_FORMATTED'] }} руб.
                                        </span>
                                    </span>
                                    <span class="calculator-type-img cover-img">
                                        <picture v-if="construct['PICTURE']">
                                            <source :srcset="construct['PICTURE']['SRC'] + ' 1x'"
                                                    :type="construct['PICTURE']['CONTENT_TYPE']">
                                            <img :src="construct['PICTURE']['SRC']" :alt="construct['NAME']">
                                        </picture>
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="calculator-step calculator-step-product tab-block" :class="{active: currentStep === 3}"
                         v-if="currentStep === 3">
                        <div class="calculator-product">
                            <div class="calculator-product-img">
                                <picture v-if="selectedConstructImage">
                                    <source :srcset="selectedConstructImage['SRC'] + ' 1x'"
                                            :type="selectedConstructImage['CONTENT_TYPE']">
                                    <img :src="selectedConstructImage['SRC']" :alt="selectedConstruct['NAME']">
                                </picture>
                                <div class="calculator-product-title h2 visible-mobile">
                                    {{ selectedConstruct['FULL_NAME_VALUE'] }}
                                </div>

                                <div class="calculator-section calculator-section-total hidden-mobile">
                                    <div class="calculator-total">
                                        <div class="calculator-total-title">Стоимость:</div>
                                        <div class="calculator-total-cost h2">{{ formattedSummaryPrice }} руб.</div>
                                    </div>
                                    <a href="#" class="calculator-add-to-cart-btn btn btn-full-width"
                                       @click.prevent.stop="addProductToCart()">
                                        {{ isEditingMode ? 'Изменить' : 'Добавить в корзину' }}
                                    </a>
                                </div>


                            </div>
                            <div class="calculator-product-body">
                                <div class="calculator-product-title h2 hidden-mobile">
                                    {{ selectedConstruct['FULL_NAME_VALUE'] }}
                                </div>
                                <div class="calculator-section" v-if="isPartitions && !isPartitionsWithoutDoor">

                                    <div class="form-block">
                                        <div class="calculator-section-title h3">
                                            Количество дверей
                                        </div>
                                        <div class="select-number">
                                            <button type="button" aria-label="Убавить"
                                                    class="select-number-btn select-number-btn-minus"
                                                    :class="{disabled: KDoor === 1}" @click="KDoor--">
                                                <svg width="16" height="16">
                                                    <use xlink:href="#icon-minus"/>
                                                </svg>
                                            </button>
                                            <input type="text" class="select-number-input input" data-min="1"
                                                   data-max="99999" inputmode="numeric" :value="KDoor"
                                                   @focus="kDoorFocus" @blur="kDoorBlur">
                                            <button type="button" aria-label="Прибавить"
                                                    class="select-number-btn select-number-btn-plus"
                                                    :class="{disabled: KDoor === 99999}"
                                                    @click="KDoor++">
                                                <svg width="16" height="16">
                                                    <use xlink:href="#icon-plus"/>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="calculator-section">
                                    <div class="calculator-section-head">
                                        <div class="calculator-section-title h3">Цвет стекла</div>
                                        <a href="#" class="calculator-section-edit-link" data-text="Изменить"
                                           data-text-active="Скрыть">Изменить</a>
                                    </div>
                                    <div class="calculator-section-selected tab-block active">
                                        {{ selectedGlass['NAME'] }}
                                    </div>
                                    <div class="calculator-props tab-block">
                                        <label v-for="(glassItem, article) in constructGlasses"
                                               class="radio-label calculator-prop" :key="glassItem['ID']"
                                               :class="{active: selectedGlassArticle === article}">
                                            <input type="radio" class="radio-input" name="glass_color" :value="article"
                                                   v-model="selectedGlassArticle"
                                                   :checked="selectedGlassArticle === article">
                                            <span class="calculator-prop-img cover-img">
                                                <span class="radio-label-icon">
                                                    <svg width="12" height="12"><use xlink:href="#icon-checkbox"/></svg>
                                                </span>
                                                <picture v-if="glassItem['PICTURE']">
                                                    <source :srcset="glassItem['PICTURE']['SRC'] + ' 1x'"
                                                            :type="glassItem['PICTURE']['CONTENT_TYPE']">
                                                    <img :src="glassItem['PICTURE']['SRC']" :alt="glassItem['NAME']">
                                                </picture>
                                            </span>
                                            <span class="calculator-prop-title">{{ glassItem['NAME'] }}</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="calculator-section">
                                    <div class="calculator-section-head">
                                        <div class="calculator-section-title h3">Декорирование</div>
                                        <a href="#" class="calculator-section-edit-link" data-text="Изменить"
                                           data-text-active="Скрыть">Изменить</a>
                                    </div>
                                    <div class="calculator-section-selected tab-block active">
                                        {{ selectedDecoration['NAME'] }}
                                    </div>
                                    <div class="calculator-props tab-block">
                                        <label v-for="(decorationItem, article) in constructDecoration"
                                               class="radio-label calculator-prop" :key="decorationItem['ID']"
                                               :class="{active: selectedDecorationArticle === article}">
                                            <input type="radio" class="radio-input" name="decor" :value="article"
                                                   v-model="selectedDecorationArticle"
                                                   :checked="selectedDecorationArticle === article">
                                            <span class="calculator-prop-img cover-img">
                                                <span class="radio-label-icon">
                                                    <svg width="12" height="12"><use xlink:href="#icon-checkbox"/></svg>
                                                </span>
                                                <picture v-if="decorationItem['PICTURE']">
                                                    <source :srcset="decorationItem['PICTURE']['SRC'] + ' 1x'"
                                                            :type="decorationItem['PICTURE']['CONTENT_TYPE']">
                                                    <img :src="decorationItem['PICTURE']['SRC']"
                                                         :alt="decorationItem['NAME']">
                                                </picture>
                                            </span>
                                            <span class="calculator-prop-title">{{ decorationItem['NAME'] }}</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="calculator-section">
                                    <div class="calculator-section-title h3">
                                        {{ sizesSectionTitle }}:
                                    </div>
                                    <ul class="calculator-checkbox-list" v-if="!isFences && !isPartitions">
                                        <li v-for="(sizes, index) in standardSizes">
                                            <label class="radio-label" :class="{active: sizes.active}">
                                                <input type="radio" class="radio-input" name="size"
                                                       :checked="sizes.active" data-toggle-block :value="index"
                                                       v-model="selectedSizesIndex">
                                                <span class="radio-label-icon">
                                                    <svg width="12" height="12"><use xlink:href="#icon-checkbox"/></svg>
                                                </span>
                                                <span class="radio-label-title">
                                                    {{ sizes.title }}
                                                </span>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="radio-label"
                                                   :class="{active: selectedSizesIndex === 'custom'}">
                                                <input type="radio" class="radio-input" name="size"
                                                       v-model="selectedSizesIndex"
                                                       data-toggle-block="calculator-custom-size" value="custom">
                                                <span class="radio-label-icon">
                                                    <svg width="12" height="12"><use xlink:href="#icon-checkbox"/></svg>
                                                </span>
                                                <span class="radio-label-title">Другой размер</span>
                                            </label>
                                        </li>
                                    </ul>
                                    <ul id="calculator-custom-size" class="calculator-custom-size tab-block"
                                        :class="{active: selectedSizesIndex === 'custom'}">
                                        <li>
                                            <div class="form-block">
                                                <div class="form-block-title">{{ `Высота, ${this.measure}` }}</div>
                                                <label class="input-block" :aria-label="`Высота, ${this.measure}`">
                                                    <input type="text" class="input" v-model="height">
                                                </label>
                                            </div>
                                        </li>
                                        <li v-show="!isFences">
                                            <div class="form-block">
                                                <div class="form-block-title">
                                                    {{ isPartitions ? `Ширина, ${this.measure}` : `Сторона 1, ${this.measure}` }}
                                                </div>
                                                <label class="input-block" :aria-label="`Сторона 1, ${this.measure}`">
                                                    <input type="text" class="input" v-model="sideSize1"
                                                           :disabled="isFences" :readonly="isFences">
                                                </label>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="form-block"
                                                 v-if="selectedConstruct['THIRD_SIZE'] && !isFences && !isPartitions">
                                                <div class="form-block-title">{{ `Сторона 2, ${this.measure}` }}</div>
                                                <label class="input-block" :aria-label="`Сторона 2, ${this.measure}`">
                                                    <input type="text" class="input" v-model="sideSize2">
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="calculator-section" v-show="false">
                                    <div class="calculator-section-title h3">Фурнитура:</div>
                                    <ul class="calculator-selected-list" v-if="selectedConstruct['HARDWARE_SET']">
                                        <li v-for="hardware in selectedConstruct['HARDWARE_SET']" :key="hardware['ID']">
                                            <div class="calculator-selected-list-title">
                                                <span>{{ hardware['NAME'] }}</span></div>
                                            <div class="calculator-selected-list-data">
                                                {{ hardware['QUANTITY'] }} шт.
                                            </div>
                                        </li>
                                    </ul>
                                    <ul class="calculator-checkbox-list">
                                        <li>
                                            <label class="checkbox-label switcher-label active">
                                                <input type="radio" class="radio-input" name="hardware_type" checked
                                                       value="default" v-model="furnitureType">
                                                <span class="switcher-label-title">Обычный</span>
                                                <span class="switcher-label-price">+ {{ pfFormatted }} руб.</span>
                                                <span class="switcher"></span>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="checkbox-label switcher-label">
                                                <input type="radio" class="radio-input" name="hardware_type"
                                                       value="premium" v-model="furnitureType">
                                                <span class="switcher-label-title">Премиум</span>
                                                <span class="switcher-label-price">
                                                    + {{ pfPremiumFormatted }} руб.</span>
                                                <span class="switcher"></span>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                <div class="calculator-section">
                                    <div class="calculator-section-title h3">Дополнительно:</div>
                                    <ul class="calculator-checkbox-list">
                                        <li v-show="isDoors || (isPartitions && !isPartitionsWithoutDoor)">
                                            <label class="checkbox-label switcher-label" :class="{active: lockEnabled}">
                                                <input type="checkbox" class="checkbox-input" v-model="lockEnabled">
                                                <span class="switcher-label-title">Добавить замки</span>
                                                <span class="switcher-label-price" v-show="false">
                                                    + {{ lockPriceFormatted }} руб.
                                                </span>
                                                <span class="switcher"></span>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="checkbox-label switcher-label"
                                                   :class="{active: mountingEnabled}">
                                                <input type="checkbox" class="checkbox-input" v-model="mountingEnabled">
                                                <span class="switcher-label-title">Монтаж</span>
                                                <span class="switcher-label-price" v-show="false">
                                                    + {{ mountingPriceFormatted }} руб.
                                                </span>
                                                <span class="switcher"></span>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="checkbox-label switcher-label"
                                                   :class="{active: deliveryEnabled}">
                                                <input type="checkbox" class="checkbox-input" v-model="deliveryEnabled">
                                                <span class="switcher-label-title">Доставка</span>
                                                <span class="switcher-label-price">
                                                    + {{ deliveryPriceFormatted }} руб.
                                                </span>
                                                <span class="switcher"></span>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                <div class="calculator-section" v-show="!isMirrors && !isPartitions">
                                    <div class="form-block">
                                        <div class="calculator-section-title h3">
                                            {{ isFences ? 'Количество погонных метров' : 'Количество' }}
                                        </div>
                                        <div class="select-number">
                                            <div class="select-number-cost">
                                                {{ formattedPrice }} руб. / {{ isFences ? 'п.м.' : 'шт.' }}
                                            </div>
                                            <button type="button" aria-label="Убавить"
                                                    class="select-number-btn select-number-btn-minus"
                                                    :class="{disabled: quantity === 1}" @click="quantity--">
                                                <svg width="16" height="16">
                                                    <use xlink:href="#icon-minus"/>
                                                </svg>
                                            </button>
                                            <input type="text" class="select-number-input input" data-min="1"
                                                   :data-max="availableQuantity" inputmode="numeric"
                                                   :value="quantityTitle" @focus="quantityFocus" @blur="quantityBlur">
                                            <button type="button" aria-label="Прибавить"
                                                    class="select-number-btn select-number-btn-plus"
                                                    :class="{disabled: quantity === availableQuantity}"
                                                    @click="quantity++">
                                                <svg width="16" height="16">
                                                    <use xlink:href="#icon-plus"/>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="calculator-section calculator-section-total visible-mobile">
                                    <div class="calculator-total">
                                        <div class="calculator-total-title">Стоимость:</div>
                                        <div class="calculator-total-cost h2">{{ formattedSummaryPrice }} руб.</div>
                                    </div>
                                    <a href="#" class="calculator-add-to-cart-btn btn btn-full-width"
                                       @click.prevent.stop="addProductToCart()">
                                        {{ isEditingMode ? 'Изменить' : 'Добавить в корзину' }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="calculator-step calculator-step-cart tab-block" :class="{active: currentStep === 4}"
                         v-if="currentStep === 4">
                        <div class="calculator-cart-wrapp">
                            <div class="calculator-cart">
                                <div class="calculator-cart-item" v-for="cartProduct in cart"
                                     :key="cartProduct['CART_PRODUCT_ID']">
                                    <a href="#" class="calculator-cart-product"
                                       @click.prevent="editCartProduct(cartProduct)">
                                        <span class="calculator-cart-product-img cover-img">
                                            <picture v-if="cartProduct['IMAGE']">
                                                <source :srcset="cartProduct['IMAGE']['SRC'] + ' 1x'"
                                                        :type="cartProduct['IMAGE']['CONTENT_TYPE']">
                                                <img :src="cartProduct['IMAGE']['SRC']" :alt="cartProduct['NAME']">
                                            </picture>
                                            <picture v-else-if="cartProduct['PICTURE']">
                                                <source :srcset="cartProduct['PICTURE']['SRC'] + ' 1x'"
                                                        :type="cartProduct['PICTURE']['CONTENT_TYPE']">
                                                <img :src="cartProduct['PICTURE']['SRC']" :alt="cartProduct['NAME']">
                                            </picture>
                                        </span>
                                        <span class="calculator-cart-product-body">
                                            <span class="calculator-cart-product-title">
                                                {{ cartProduct['NAME'] }}
                                            </span>
                                            <span class="calculator-cart-item-price visible-mobile">
                                                <span class="h3">{{ cartProduct['FORMATTED_SUMMARY_PRICE'] }}</span> руб.
                                            </span>
                                        </span>
                                    </a>
                                    <div class="calculator-cart-item-price hidden-mobile">
                                        <span class="h3">{{ cartProduct['FORMATTED_SUMMARY_PRICE'] }}</span> руб.
                                    </div>
                                    <a href="#" class="calculator-cart-item-remove" aria-label="Удалить"
                                       @click.prevent="removeCartProduct(cartProduct, $event)">
                                        <svg width="12" height="12">
                                            <use xlink:href="#icon-close"/>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                            <div class="calculator-section calculator-section-total">
                                <div class="calculator-total">
                                    <div class="calculator-total-title">Стоимость:</div>
                                    <div class="calculator-total-cost">
                                        <span class="h2">{{ cartSummaryFormatted }}</span> руб.
                                    </div>
                                </div>
                                <a href="#" class="calculator-submit btn btn-full-width" v-if="!isHashPage"
                                   @click.prevent="currentStep = 5">
                                    Перейти к оформлению
                                </a>
                                <a href="#" class="btn btn-full-width" v-if="!isHashPage"
                                   @click.prevent="currentStep = 1">
                                    Добавить еще
                                </a>
                                <a href="#" class="btn btn-full-width" v-else @click.prevent="saveHashPage">
                                    Продолжить работу с корзиной
                                </a>
                            </div>
                            <ul class="calculator-cart-action-links">
                                <li>
                                    <a href="#" class="calculator-cart-action-link calculator-section"
                                        @click.prevent="pdfCalculator()">
                                        <div class="calculator-cart-action-link-icon">
                                            <svg width="24" height="24">
                                                <use xlink:href="#icon-document"/>
                                            </svg>
                                        </div>
                                        <div class="calculator-cart-action-link-title">
                                            Сформировать PDF
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" class="calculator-cart-action-link calculator-section"
                                       @click.prevent="copyCalculatorCart()">
                                        <div class="calculator-cart-action-link-icon">
                                            <svg width="24" height="24">
                                                <use xlink:href="#icon-copy"/>
                                            </svg>
                                        </div>
                                        <div ref="basketCopyText" class="calculator-cart-action-link-title">
                                            Скопировать ссылку на расчет
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <form action="?" class="calculator-step calculator-step-cart tab-block calculator-ordering-form"
                          :class="{active: currentStep === 5}" v-if="currentStep === 5">
                        <div class="calculator-cart-wrapp">
                            <div class="calculator-section calculator-ordering-inputs">
                                <div class="form-block">
                                    <div class="form-block-title">Имя *</div>
                                    <label class="input-block" aria-label="Имя *">
                                        <input type="text" class="input" required v-model="name">
                                    </label>
                                </div>
                                <div class="form-block">
                                    <div class="form-block-title">E-mail *</div>
                                    <label class="input-block" aria-label="E-mail *">
                                        <input type="email" class="input" required v-model="email">
                                    </label>
                                </div>
                                <div class="form-block">
                                    <div class="form-block-title">Телефон *</div>
                                    <label class="input-block" aria-label="Телефон *">
                                        <input type="tel" class="input" name="phone" required v-model="phone" ref="formPhone">
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="calculator-section calculator-section-total">
                            <div class="calculator-total">
                                <div class="calculator-total-title">Стоимость:</div>
                                <div class="calculator-total-cost">
                                    <span class="h2">{{ cartSummaryFormatted }}</span> руб.
                                </div>
                            </div>
                            <button type="submit" class="calculator-submit btn btn-full-width" disabled
                                    @click.prevent.stop="sendOrder()">
                                Оформить заказ
                            </button>
                        </div>
                    </form>
                </div>
                <div v-if="isEmptyCart" class="calculator-foot tab-block" :class="{active: currentStep < 3}">
                    <div class="calculator-foot-body">
                        <div class="calculator-foot-products">Нет товаров</div>
                        <a href="#" class="btn calculator-cart-btn disabled">
                            В корзину
                        </a>
                    </div>
                </div>
                <div v-else class="calculator-foot tab-block" :class="{active: currentStep < 3 && !isEditingMode}">
                    <div class="calculator-foot-body">
                        <div class="calculator-foot-products">
                            <div class="calculator-foot-product cover-img" @click.prevent="currentStep = 4"
                                 v-for="cartProduct in firstThreeCartElements" :key="cartProduct['CART_PRODUCT_ID']">
                                <picture v-if="cartProduct['IMAGE']">
                                    <source :srcset="cartProduct['IMAGE']['SRC'] + ' 1x'"
                                            :type="cartProduct['IMAGE']['CONTENT_TYPE']">
                                    <img :src="cartProduct['IMAGE']['SRC']" :alt="cartProduct['NAME']">
                                </picture>
                                <picture v-else-if="cartProduct['PICTURE']">
                                    <source :srcset="cartProduct['PICTURE']['SRC'] + ' 1x'"
                                            :type="cartProduct['PICTURE']['CONTENT_TYPE']">
                                    <img :src="cartProduct['PICTURE']['SRC']" :alt="cartProduct['NAME']">
                                </picture>
                            </div>
                            <div v-if="cartLength > 3" class="calculator-foot-product calculator-foot-product-count">
                                {{ cartLength > 8 ? '8+' : `+${(cartLength - 3)}` }}
                            </div>
                        </div>
                        <a href="#" class="btn calculator-cart-btn" @click.prevent="currentStep = 4">
                            В корзину
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script src="./Calculator.js"></script>